<template>
  <div>
    <v-text-field disabled :label="label" prepend-icon="event"/>
    <div class="date-flex">
      <div>
        <v-select label="Day" v-model="day" autocomplete :items="days" attach/>
      </div>
      <div>
        <v-select label="Month" v-model="month" autocomplete :items="months" attach/>
      </div>
      <div>
        <v-select label="Year" v-model="year" autocomplete :items="years" attach/>
      </div>
    </div>
  </div>
</template>

<script>
const thisYear = new Date().getFullYear()

function getMonth (id) {
  return [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ][id - 1]
}

export default {
  inject: ['$validator'],
  props: {
    label: { default: '', type: String },
    value: {},
    today: { default: false, type: Boolean }
  },
  data () {
    return {
      day: 1,
      month: 1,
      year: thisYear - 40,
      inputVal: this.value
    }
  },
  computed: {
    dayLength () {
      if ([4, 6, 9, 11].includes(this.month)) return 30
      if (this.month !== 2) return 31
      return this.year % 4 === 0 ? 29 : 28
    },
    days () {
      return [...Array(this.dayLength).keys()].map(x => ({
        value: x + 1,
        text: `${x < 9 ? '0' : ''}${x + 1}`
      }))
    },
    months: () => [...Array(12).keys()].map(x => ({
      value: x + 1,
      text: getMonth(x + 1)
    })),
    years () {
      return this.today ? [...Array(thisYear + 1 - 1800).keys()].map(x => thisYear + 1 - x) : [...Array(thisYear - 1800).keys()].map(x => thisYear - x)
    },
    birthdate () {
      let d = new Date(new Date(this.year, this.month - 1, this.day))
      return new Date(d.getTime() - d.getTimezoneOffset() * 60 * 1000).toISOString()
    }
  },
  methods: {
    updateDay () {
      if (this.day > this.dayLength) this.day = this.dayLength
      this.$emit('input', this.birthdate)
    }
  },
  watch: {
    'day': function (newVal) { this.updateDay() },
    'month': function (newVal) { this.updateDay() },
    'year': function (newVal) { this.updateDay() }
  },
  mounted () {
    if (this.today) {
      let d = new Date()
      this.day = d.getDate()
      this.month = d.getMonth() + 1
      this.year = d.getFullYear()
    } else {
      this.updateDay()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/date-field.vue